export default __webpack_public_path__ + "static/media/ios-arrow-thin-right.d07302c8.svg";